import React, { useCallback, useEffect, useState } from 'react';
import { Grid, makeStyles } from '@material-ui/core';
import CustomMultiSelect from '../../shared/CustomMultiSelect';
import CustomButton from '../../shared/CustomButton';
import CustomDropDown from '../../shared/CustomDropDown';
import { dealershipSortOptions } from '../constants';

const useStyles = makeStyles({
  detailsContainer: {
    padding: '8px 0px 0px 6px',
    background: 'rgba(242, 244, 247, 1)',
  },
  dropdownContainer: {
    marginRight: '20px',
  },
  filter: {
    marginRight: '8px',
  },
});

const DealershipFilter = ({ filters, filterObjectInitial, onApplyFilters, handleSort, sortType }) => {
  const classes = useStyles();

  const [filterObj, setFilterObj] = useState(() => ({ ...filterObjectInitial }));

  useEffect(() => {
    setFilterObj({ ...filterObjectInitial });
  }, [filterObjectInitial]);

  const handleFilterUpdate = useCallback((selectedValues, label) => {
    setFilterObj((prevFilter) => ({
      ...prevFilter,
      [label]: selectedValues,
    }));
  }, []);

  const handleApply = useCallback(() => {
    onApplyFilters(filterObj);
  }, [filterObj, onApplyFilters]);

  const resetFilters = useCallback(() => {
    setFilterObj({ ...filterObjectInitial });
  }, [filterObjectInitial]);

  return (
    <Grid
      container
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      className={classes.detailsContainer}
    >
      <Grid item>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          className={classes.detailsContainer}
        >
          <Grid item className={classes.filter}>
            <CustomMultiSelect
              width="130px"
              height="32px"
              label="Plan"
              name="plans"
              list={filters?.plans}
              placeholder="Plans"
              handleFilterChange={handleFilterUpdate}
              selectedValue={filterObj.plans}
              showSelectedValues={false}
              enableSearch
            />
          </Grid>
          <Grid item className={classes.filter}>
            <CustomMultiSelect
              width="200px"
              height="32px"
              label="Sales Pipeline Status"
              name="salesPipelineStatus"
              list={filters?.salesPipelineStatus}
              placeholder="Sales Pipeline Status"
              handleFilterChange={handleFilterUpdate}
              selectedValue={filterObj.salesPipelineStatus}
              showSelectedValues={false}
              enableSearch
            />
          </Grid>
          <Grid item className={classes.filter}>
            <CustomMultiSelect
              width="150px"
              height="32px"
              label="Parent"
              name="dealerGroupIds"
              placeholder="Dealer Groups"
              list={filters?.dealerGroup}
              handleFilterChange={handleFilterUpdate}
              selectedValue={filterObj.dealerGroupIds}
            />
          </Grid>
          <Grid item className={classes.filter}>
            <CustomButton size="small" label="Apply" type="primary" onClick={handleApply} />
          </Grid>
          <Grid item>
            <CustomButton size="small" label="Reset" type="secondary" onClick={resetFilters} />
          </Grid>
        </Grid>
      </Grid>
      <Grid item className={classes.dropdownContainer}>
        <CustomDropDown
          name="dealershipSort"
          width="121px"
          height="32px"
          list={dealershipSortOptions}
          handleChange={handleSort}
          value={sortType}
          showLabel
          label="Sort"
        />
      </Grid>
    </Grid>
  );
};

export default DealershipFilter;
